/**
 * Follow the Honey Affiliate Tagging API which follows
 * a redirect chain that always ends up on the requested merchantUrl
 */
const getAffiliateLink = ({
  honeyStoreId,
  fptiSessionId,
  turl,
  encryptedAccountNumber
}: {
  honeyStoreId: string
  fptiSessionId: string
  turl?: string | null
  encryptedAccountNumber?: string
}): string => {
  if (!turl) {
    return 'https://www.joinhoney.com'
  }
  if (!honeyStoreId) {
    return turl
  }
  if (!fptiSessionId) {
    return turl
  }

  const param0 = encryptedAccountNumber
    ? `pp${encryptedAccountNumber}`
    : `p${fptiSessionId}`

  const url = new URL(`https://o.honey.io/store/${honeyStoreId}/website`)

  url.searchParams.append('afsrc', '1')
  url.searchParams.append('param0', param0)
  url.searchParams.append('af0', `p${fptiSessionId}`)
  url.searchParams.append('src', 'paypal-shopping')
  url.searchParams.append('feat', 'ppd')
  url.searchParams.append('cat', 'deeplink')
  url.searchParams.append('turl', turl)

  return url.toString()
}

export default getAffiliateLink
